import { FlatList, View } from "react-native";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { graphql, useLazyLoadQuery } from "react-relay";
import { DashboardsAdminQuery } from "./__generated__/DashboardsAdminQuery.graphql";
import { AHSeparator, ListItem } from "arkh";
import { FormattedMessage } from "react-intl";
import { StoreAdminNavigationScreenProps } from "./StoreAdminNavigation";
import { ActionFooter } from "@/src/components/ActionFooter";

type Props = StoreAdminNavigationScreenProps<"DashboardsAdmin">;

function DashboardsAdminComponent(props: Props & { fetchKey: string }) {
  const data = useLazyLoadQuery<DashboardsAdminQuery>(
    graphql`
      query DashboardsAdminQuery {
        store {
          dashboards {
            id
            name
          }
        }
      }
    `,
    {},
    { fetchPolicy: "store-and-network", fetchKey: props.fetchKey }
  );

  const items = data.store.dashboards.filter((item) => item?.id);

  return (
    <View style={{ flex: 1 }}>
      <FlatList
        data={items}
        keyExtractor={(item) => item.id}
        ListFooterComponent={AHSeparator}
        renderItem={({ item }) => {
          return (
            <ListItem
              right={<ListItem.NavArrow />}
              onPress={() => {
                props.navigation.navigateDeprecated("StorecastSettings", {
                  storecastId: item.id,
                });
              }}
            >
              <ListItem.Title>{item.name}</ListItem.Title>
            </ListItem>
          );
        }}
        ItemSeparatorComponent={AHSeparator}
      />

      <ActionFooter
        safeInsetBottom
        primary={
          <ActionFooter.Primary
            title={
              <FormattedMessage
                defaultMessage="Create Dashboard"
                description="Dashboards Admin create dashboard"
              />
            }
            icon="add"
            onPress={() => {
              props.navigation.navigateDeprecated("StorecastCreate", {});
            }}
          />
        }
      />
    </View>
  );
}

export function DashboardsAdmin(props: Props) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fetchKey) => (
        <DashboardsAdminComponent {...props} fetchKey={fetchKey} />
      )}
    </LazyQueryNetworkBoundrary>
  );
}
